export default "__VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__ 480w, __VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__ 680w";